import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

@Injectable()
export class CompanyGuard implements CanActivate {
    constructor(
        private router: Router
    ) { }

    canActivate(route: ActivatedRouteSnapshot) {
        if (route.parent.data['external']) {
            return true;
        }

        if (localStorage.getItem('companyAccess') == 'GRANTED') {
            return true;
        }
        else {
            alert('Keine Berechtigung')
            this.router.navigate(['/dashboard'])
            return false;
        }
    }
}